import { render, staticRenderFns } from "./ProfileTable.vue?vue&type=template&id=5ca2c738&scoped=true&"
import script from "./ProfileTable.vue?vue&type=script&lang=js&"
export * from "./ProfileTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca2c738",
  null
  
)

export default component.exports